// extracted by mini-css-extract-plugin
export default {"projects":"styles_projects__3NtSG","projectsDark":"styles_projectsDark__KZhwF","projectsLight":"styles_projectsLight__ERZcT"};